import React from 'react';
import { NavLink } from 'react-router-dom';

const EmployeesCrumb = () => <NavLink to="/human-resources/employees">Employees</NavLink>;

export default EmployeesCrumb;
